import React from "react";
import ReactModal from "react-modal";
import * as R from "ramda";
import UserFormFields from "./UserFormFields";
import { connect } from "react-redux";
import { updateOne } from "actions/user";
import { fetchAll } from "actions/location";
import Icon from "components/Icon";

const mapStateToProps = state => ({
  isUpdating: state.user.isUpdating,
  locations: state.location.byId,
  isFetching: state.location.isFetching
});

const mapDispatchToProps = { updateOne, fetchAll };

class UpdateUserModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      user: { ...props.user }
    };
  }

  handleSubmit = event => {
    event.preventDefault();
    const { updateOne } = this.props;
    const { user } = this.state;
    updateOne(user.id, user).then(this.handleCloseModal);
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  handleOpenModal = () => {
    this.setState({ showModal: true });
    this.props.fetchAll();
  };

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  handleDelete = () => {
    this.props.onDelete(this.props.id).then(this.handleCloseModal);
  };

  render() {
    const { title, locations, isFetching } = this.props;
    const items = Object.keys(locations).map(id => locations[id]);
    if (!(!isFetching && items)) {
      return null;
    }
    return (
      <div>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.handleOpenModal}
        >
          <Icon icon="pencil-alt" />
        </button>
        <ReactModal
          onRequestClose={this.handleCloseModal}
          className="Modal"
          overlayClassName="Overlay"
          isOpen={this.state.showModal}
          contentLabel="Delete Confirmation"
        >
          <form onSubmit={this.handleSubmit}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                </div>
                <div className="modal-body">
                  <UserFormFields
                    user={this.state.user}
                    onChange={this.handleChange}
                    nodate
                    nocustomer
                    location={items}
                  />
                </div>
                <div className="modal-footer">
                  <button className="btn btn-primary" type="submit">
                    Rediger
                  </button>
                  <button className="btn" onClick={this.handleCloseModal}>
                    Avbryt
                  </button>
                </div>
              </div>
            </div>
          </form>
        </ReactModal>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserModal);



// WEBPACK FOOTER //
// ./src/components/UpdateUserModal.js